module.exports = __webpack_public_path__ + "img/google.87be59a1.svg";